
import { Unit } from "@/models/unit";
import { UnitService } from "@/services/unit-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			units: [] as Unit[],
		};
	},
	props: {
		label: String,
		value: String,
		fancy: Boolean,
		lang: String,
		hasError: Boolean
	},
	computed: {
		selectedLang(): string {
			return this.lang || this.$i18n.locale;
		},
		items(): string[] {
			return this.units.map(u => u.Name.getTranslation(this.selectedLang));
		},
		isOpened():boolean {
			let el = this.$refs.el as any;
			if (!el) return false;
			return el.isOpened;
		}
	},
	methods: {
		onInput(event: string) {
			this.$emit("input", event);
		},
		focus() {
			let el = this.$refs.el as any;
			if (!el || !el.focus) return;
			el.focus();
		},
		onFocus() {
			this.$emit("focus");
		},
		onBlur() {
			this.$emit("blur");
		},
		onKeyup(event: KeyboardEvent) {
			this.$emit("keyup", event);
		}
	},
	created() {
		this.units = UnitService.getUnits();
	}
});
